import React from 'react';
import { Box, Typography } from '@mui/material';
import { StudioFlowColors } from '../studioFlowTheme';

interface FlowDividerProps {
  label: string;
}

export const FlowDivider: React.FC<FlowDividerProps> = ({ label }) => (
  <Box sx={{ position: 'relative', my: 2, height: 36, display: 'flex', alignItems: 'center' }}>
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        top: '50%',
        borderTop: `1px solid ${StudioFlowColors.unfocused}`,
      }}
    />
    <Typography
      variant="body2"
      sx={{
        position: 'relative',
        mx: 'auto',
        px: 1,
        bgcolor: StudioFlowColors.background,
        color: StudioFlowColors.accent,
        fontSize: 13,
        letterSpacing: '-0.13px',
        fontFamily: StudioFlowColors.bodyFontFamily,
      }}
    >
      {label}
    </Typography>
  </Box>
);
